module.exports = __webpack_public_path__ + "img/technology@2x.1d0ea44.jpg";